// page-company.jsx — /recruit/company/ 会社を知る
// 方針doc（PR #130）4-3 に沿って、現行 /recruit/ の
//   HISTORY / DATA / MEMBERS / TEAM MEMBERS / VALUES / OFFICE & TEAM
// をこのページへ移設したもの。数値は PR #132 で ERP に揃えた値。
//
// 代表メッセージ（/recruit/message/ の統合分）は、代表インタビュー後に
// このページの先頭へ追加する。現時点ではプレースホルダも置いていない。
//
// 注意: 現行 /recruit/ 側にも同じセクションが残っている。トップを抜粋のみに
// 縮める改修（方針doc 9章 順7）が別途入るまでの一時的な重複。

(function(){
  const { HBLayout, HBSubHero, hbcp, fontEN, fontENSans, fontJP, fontMono, HB_BASE, HB_WANTEDLY } = window;
  const fontSerif = '"Zen Kaku Gothic New", "Noto Sans JP", sans-serif';

  const HISTORY = [
    { date:'2023年 2月',  body:'はてなベース株式会社を創業。資金調達支援とシステム受託開発を主事業としてスタート。' },
    { date:'2023年 7月',  body:'早稲田オフィスに移転。' },
    { date:'2023年 12月', body:'kintone 導入支援事業をスタート。税理士法人を中心にバックオフィスの業務改善を始める。' },
    { date:'2024年 2月',  body:'教育研修事業をスタート。DX や会計ソフト導入の事例を中心とするコンテンツ制作 / 販売を開始。' },
    { date:'2024年 8月',  body:'sankyodo 税理士法人と協業し、一般社団法人 DIGITALBASE の理事として参画。会計事務所向け kintone パッケージの販売等を行う。' },
    { date:'2024年 10月', body:'四谷三丁目オフィスに移転。メンバー数が 40 人を超え、新規事業チームの発足とともにオフィスを移転。' },
    { date:'2024年 12月', body:'会計ソフト自動連動型の BI ツールをリリース。IR 資料や金融機関向けの財務資料の効率的な作成を可能にする BI ツールの販売を開始。' },
    { date:'2025年 5月',  body:'はてなベース株式会社の HP をリニューアル。' },
    { date:'2025年 7月',  body:'はてなベース社会保険労務士事務所を設立、はてなベース税理士法人に名称変更。' },
    { date:'2026年 2月',  body:'はてなベース株式会社 京都支店を京都市中京区に設立。' },
  ];

  // 数値データ (HR Report P10)
  const DATA_BASIC = [
    { en:'FOUNDED',          jp:'創業',         v:'2023.02', sub:'設立 3 年' },
    { en:'EMPLOYEES',        jp:'従業員数',     v:'55',      sub:'人 (含 業務委託)' },
    { en:'AVG. AGE',         jp:'平均年齢',     v:'26.5',    sub:'歳' },
    { en:'FULL-TIME',        jp:'正社員数',     v:'2',       sub:'人' },
    { en:'YOY GROWTH',       jp:'前年比成長率', v:'163',     sub:'%' },
  ];
  // 受験生 / 有資格者 (P10 続き)
  const DATA_QUALIFY = [
    { label:'税理士受験生',          v:3 },
    { label:'会計士受験生',          v:4 },
    { label:'論文式合格者',          v:8 },
    { label:'税理士有資格者',        v:3 },
    { label:'公認会計士有資格者',    v:3 },
  ];

  // メンバー内訳 (P11 / P13)
  const MEMBERS_AGE = [
    { label:'10代',  n:3,  pct:5,  color:'#D8C4B0' },
    { label:'20代',  n:38, pct:65, color:hbcp.blue },
    { label:'30代',  n:16, pct:28, color:'#1A4D4D' },
    { label:'40代+', n:1,  pct:2,  color:'#5C2B45' },
  ];
  const MEMBERS_DEPT = [
    { label:'開発（DX 事業部）', n:24 },
    { label:'会計',              n:18 },
    { label:'研修',              n:6 },
    { label:'バックオフィス',     n:2 },
    { label:'事業部横断',         n:5 },
  ];
  const MEMBERS_JOB = [
    { label:'エンジニア',                       n:26 },
    { label:'会計スタッフ',                     n:10 },
    { label:'コーポレート',                     n:5  },
    { label:'公認会計士・税理士有資格者',       n:5  },
    { label:'税理士事務所勤務',                 n:4  },
    { label:'デザイナー・クリエイター',         n:4  },
    { label:'プロジェクトマネジャー',           n:2  },
    { label:'セールス',                         n:2  },
  ];
  const MEMBERS_GENDER = [
    { label:'男性', n:38, pct:69 },
    { label:'女性', n:20, pct:31 },
  ];

  // チームメンバー (P8)
  const TEAM = [
    {
      name:'世戸口 逸人',
      role:'代表取締役',
      img:(window.HB_ASSETS||'')+'images/wantedly/m-setoguchi.jpg',
      bio:'慶應義塾大学在学中に公認会計士論文式試験合格。その後 PwC あらた有限責任監査法人に入所。飲食 DX を手がけるベンチャー企業に転職後、2023 年 2 月にはてなベース株式会社を創業。同年 8 月のはてなベース税理士法人の創業に関わる。一般社団法人 DIGITALBASE 理事。公認会計士。',
    },
    {
      name:'宮澤 孝慈',
      role:'最高技術責任者 / DX 事業部長',
      img:(window.HB_ASSETS||'')+'images/wantedly/m-miyazawa.jpg',
      bio:'慶應義塾大学でデータサイエンスを学び、学部卒業後は同大学の修士課程に進学。在学中から B2C サービスの起業を通じてシステム開発にも取り組みながら、医療系上場企業にてデータ解析を担当。その後、金融機関のデータベースを改修しバックオフィスの DX を実現。現在は kintone を中心とする CRM の導入支援、生成 AI を使ったデータ解析を得意とする。',
    },
    {
      name:'三輪 衛',
      role:'会計コンサルティング事業部 事業部長',
      img:(window.HB_ASSETS||'')+'images/wantedly/m-miwa.jpg',
      bio:'慶應義塾大学在学中に創業 1 期目のベンチャー企業を 2 年間経験し、新規事業部の立ち上げを行う。その後不動産デベロッパーを経てはてなベース株式会社に入社。現在は融資支援や企業財務分析を行いつつ、バックオフィスの責任者を務める。',
    },
    {
      name:'岡田 昇陽',
      role:'DX コンサルタント / DX 事業部',
      img:(window.HB_ASSETS||'')+'images/wantedly/m-okada.jpg',
      bio:'株式会社リクルートで営業、管理職を経験し、その後 Web エンジニアとして独立。フロントエンドからバックエンド開発、Web デザインなど幅広い領域でプロジェクトを推進。現在は東京大学で AI 研究にも携わっており、様々な側面からの DX 支援を得意としている。',
    },
    {
      name:'川島 史奈',
      role:'採用広報',
      img:(window.HB_ASSETS||'')+'images/wantedly/m-kawashima.jpg?v=20260708',
      bio:'新卒で大手飲食チェーンに入社後、中小企業のお金の流れや店舗経営に関心を抱く。飲食専門の税理士事務所・会計ベンチャーにて CS を経験。飲食店新店立ち上げ経験から人材育成にも興味を持ち、教育系ベンチャーでの学校教育での授業支援を経て、はてなベースへ。',
    },
    {
      name:'増田 和也',
      role:'会計コンサルティング事業部',
      img:(window.HB_ASSETS||'')+'images/wantedly/m-masuda.jpg',
      bio:'早稲田大学商学部卒業。新卒では経営コンサルティングファームにて事業再生 DD や M&A、IT 導入支援に従事した後、ベンチャー企業にて数十件の資金調達支援を行う。その後、ディープテック企業にて、最大 20 億円規模の補助金申請 & 管理、財務管理を担当。2025 年 8 月には同社代表取締役に就任。2026 年、はてなベース株式会社に参画。',
    },
  ];

  // VALUES (行動原則 — P19)
  const VALUES = [
    { num:'01', en:'Think 10X',         jp:'非現実的な目標から逆算しよう',                d:'スモールゴールではなく、「10 倍」を起点に考える。逆算で、いま必要な打ち手が見える。' },
    { num:'02', en:'Take Ownership',    jp:'自ら機会を創り、まずは一歩目をスタートしよう', d:'指示を待たない。課題を自分の領分として引き受け、最初の一歩を踏み出す。' },
    { num:'03', en:'Master Your Craft', jp:'一芸に秀で、一芸を極めよう',                  d:'一般論ではなく、自分にしかない一芸を磨き続ける。それが組織の合計値を変える。' },
  ];

  // 出身企業・大学 (P11)

  // ─────────────────────────────────────────────────────────
  // 円グラフコンポーネント (CSS conic-gradient ベース)
  // ─────────────────────────────────────────────────────────
  function PieChart({ data, size = 220 }) {
    let acc = 0;
    const stops = data.map( d => {
      const start = acc;
      acc += d.pct;
      return `${d.color || hbcp.blue} ${start}% ${acc}%`;
    } ).join(', ');
    return (
      <div style={{
        width:size, height:size, borderRadius:'50%',
        background:`conic-gradient(${stops})`,
        position:'relative', flexShrink:0,
      }}>
        <div style={{
          position:'absolute', inset:'22%', borderRadius:'50%', background:'#fff',
          display:'grid', placeItems:'center', textAlign:'center',
        }}>
          <div>
            <div style={{fontFamily:fontEN, fontSize:38, fontWeight:300, color:hbcp.ink, lineHeight:1}}>
              {data.reduce((s,d)=>s+d.n, 0)}
            </div>
            <div style={{fontFamily:fontJP, fontSize:11, color:hbcp.inkLight, marginTop:4}}>名</div>
          </div>
        </div>
      </div>
    );
  }

  function BarRow({ label, n, total, color = hbcp.blue }) {
    const pct = Math.round( (n / total) * 100 );
    return (
      <div style={{padding:'10px 0', borderBottom:`1px solid ${hbcp.line}`}}>
        <div style={{display:'flex', justifyContent:'space-between', alignItems:'baseline', marginBottom:6}}>
          <span style={{fontFamily:fontJP, fontSize:13, color:hbcp.ink}}>{label}</span>
          <span style={{fontFamily:fontMono, fontSize:11, color:hbcp.inkLight}}>{n} 名 ・ {pct}%</span>
        </div>
        <div style={{height:6, background:hbcp.paper}}>
          <div style={{height:'100%', width:`${pct}%`, background:color}}/>
        </div>
      </div>
    );
  }

  // ─────────────────────────────────────────────────────────
  // モバイル responsive override (固定 gridTemplateColumns はモバイルで潰れるため、
  // 720px 以下で 1〜2 列に collapse する CSS を注入する)
  const RECRUIT_RESPONSIVE_CSS = `
    @media (max-width: 900px) {
      .hb-r-section { padding: 64px 20px !important; }
      .hb-r-grid-2 { grid-template-columns: 1fr !important; gap: 24px !important; }
      .hb-r-grid-3 { grid-template-columns: 1fr !important; gap: 24px !important; }
      .hb-r-grid-team { grid-template-columns: 1fr !important; gap: 16px !important; }
      .hb-r-team-card { grid-template-columns: 120px 1fr !important; gap: 16px !important; padding: 16px !important; }
      .hb-r-ceo { grid-template-columns: 1fr !important; gap: 32px !important; }
      .hb-r-office-wide { grid-template-columns: 1fr !important; gap: 12px !important; }
      .hb-r-end { grid-template-columns: 1fr !important; gap: 32px !important; }
    }
    @media (max-width: 720px) {
      .hb-r-section { padding: 48px 16px !important; }
      .hb-r-grid-5 { grid-template-columns: repeat(2, 1fr) !important; gap: 10px !important; }
      .hb-r-grid-5 > * { padding: 16px 14px !important; }
      .hb-r-grid-qualify { grid-template-columns: repeat(2, 1fr) !important; gap: 14px 18px !important; }
      .hb-r-grid-qualify > * { border-right: none !important; padding-right: 0 !important; }
      .hb-r-grid-4 { grid-template-columns: repeat(2, 1fr) !important; gap: 12px !important; }
      .hb-r-pie-legend { grid-template-columns: 1fr !important; gap: 18px !important; }
      .hb-r-team-card { grid-template-columns: 1fr !important; gap: 12px !important; }
      .hb-r-team-card > div:first-child { max-width: 200px; }
      /* OPEN POSITIONS — 5 列固定を auto/1fr の 3 行に組み替え */
      .hb-r-pos-row { grid-template-columns: auto 1fr !important; grid-template-rows: auto auto auto !important;
        column-gap: 12px !important; row-gap: 6px !important; padding: 18px 14px !important; }
      .hb-r-pos-row > *:nth-child(1) { grid-row: 1; grid-column: 1; font-size: 22px !important; }
      .hb-r-pos-row > *:nth-child(2) { grid-row: 1; grid-column: 2; align-self: center; }
      .hb-r-pos-row > *:nth-child(3) { grid-row: 2; grid-column: 1 / -1; }
      .hb-r-pos-row > *:nth-child(4) { grid-row: 3; grid-column: 1 / -1; padding-top: 6px; border-top: 1px dashed #E2DACB; }
      .hb-r-pos-row > *:nth-child(5) { display: none !important; }
      /* HERO 内ロングテキストと見出しの縮小 */
      h2.hb-r-h2-md { font-size: 22px !important; }
      /* History を縦積みタイムラインに組み替え。
         variant-d-loader の [style*="160px 1fr"] (specificity 0,1,1) を
         二重クラスで上書きし、date 行は小さい青ラベル、body 行は本文として表示。
         vertical line は consumer の認知負荷が増えるだけなので mobile では消す。 */
      .hb-r-history.hb-r-history { grid-template-columns: 1fr !important; gap: 0 !important; }
      .hb-r-history-line { display: none !important; }
      .hb-r-history-dot { display: none !important; }
      .hb-r-history-date { text-align: left !important; padding: 14px 0 0 !important; }
      .hb-r-history-body { padding: 4px 0 14px 0 !important; }
    }
  `;


  function RecruitCompanyPage() {
    const totalDept = MEMBERS_DEPT.reduce((s,d)=>s+d.n, 0);
    const totalJob  = MEMBERS_JOB.reduce((s,d)=>s+d.n, 0);

    return (
      <HBLayout>
        <style dangerouslySetInnerHTML={{__html: RECRUIT_RESPONSIVE_CSS}} />

        <HBSubHero
          crumb={'Recruit / 会社を知る'}
          en="Company"
          jp={<span>数字と、<span style={{color:hbcp.blue}}>人</span>で見る<br/>はてなベース</span>}
          tag={'Who we are.'}
          lead={'沿革・人数の内訳・行動原則・オフィスまで、入る前に知っておきたいことをまとめました。よく見せるための数字ではなく、いまの実態をそのまま載せています。'}
        />

        {/* ───── 3. HISTORY ───── */}
        <section className="hb-r-section" style={{padding:'96px 32px', background:hbcp.paper, borderBottom:`1px solid ${hbcp.line}`}}>
          <div style={{maxWidth:1280, margin:'0 auto'}}>
            <div className="hb-section-head">
              <span className="hb-section-head-en">History</span>
              <span className="hb-section-head-jp">沿革</span>
            </div>
            <p style={{fontSize:14, lineHeight:1.95, color:hbcp.inkSoft, margin:'0 0 36px', maxWidth:680}}>
              2023 年 2 月の創業から、3 年で 55 名規模・3 拠点・複数の事業ラインへ。年表で振り返ります。
            </p>
            <div className="hb-r-history" style={{display:'grid', gridTemplateColumns:'160px 1fr', gap:0, position:'relative'}}>
              {/* タイムライン縦線 */}
              <div className="hb-r-history-line" style={{position:'absolute', left:155, top:0, bottom:0, width:1, background:hbcp.line}}/>
              {HISTORY.map( (h, i) => (
                <React.Fragment key={i}>
                  <div className="hb-r-history-date" style={{padding:'14px 0', textAlign:'right', paddingRight:24, position:'relative'}}>
                    <span style={{fontFamily:fontMono, fontSize:12, fontWeight:600, color:hbcp.blue, letterSpacing:'.04em'}}>{h.date}</span>
                    {/* ドット */}
                    <span className="hb-r-history-dot" style={{position:'absolute', right:-5, top:18, width:11, height:11, borderRadius:'50%', background:hbcp.blue, border:`2px solid #fff`}}/>
                  </div>
                  <div className="hb-r-history-body" style={{padding:'14px 0 14px 24px', borderBottom: i === HISTORY.length-1 ? 'none' : `1px solid ${hbcp.line}`}}>
                    <p style={{fontSize:14.5, lineHeight:1.85, color:hbcp.ink, margin:0}}>{h.body}</p>
                  </div>
                </React.Fragment>
              ))}
            </div>
          </div>
        </section>

        {/* ───── 4. DATA ───── */}
        <section className="hb-r-section" style={{padding:'96px 32px', background:hbcp.white, borderBottom:`1px solid ${hbcp.line}`}}>
          <div style={{maxWidth:1280, margin:'0 auto'}}>
            <div className="hb-section-head">
              <span className="hb-section-head-en">Data</span>
              <span className="hb-section-head-jp">数値でみるはてなベース</span>
            </div>
            <p style={{fontSize:14, lineHeight:1.95, color:hbcp.inkSoft, margin:'0 0 32px', maxWidth:680}}>
              定石から外れた仲間が集まる、若いチーム。基本情報・在籍する会計士／税理士の人数を含めて公開します。
            </p>

            {/* 基本情報 5 カード */}
            <div className="hb-r-grid-5" style={{display:'grid', gridTemplateColumns:'repeat(5, 1fr)', gap:16, marginBottom:48}}>
              {DATA_BASIC.map( d => (
                <div key={d.en} style={{padding:'24px 22px', background:hbcp.paper, border:`1px solid ${hbcp.line}`, borderTop:`3px solid ${hbcp.blue}`}}>
                  <div style={{fontFamily:fontENSans, fontSize:9.5, letterSpacing:'.28em', color:hbcp.blue, fontWeight:700, marginBottom:6}}>{d.en}</div>
                  <div style={{fontFamily:fontJP, fontSize:11, color:hbcp.inkLight, marginBottom:14}}>{d.jp}</div>
                  <div style={{fontFamily:fontEN, fontWeight:300, fontSize:'clamp(34px, 3vw, 44px)', lineHeight:1, color:hbcp.ink}}>{d.v}</div>
                  <div style={{fontFamily:fontJP, fontSize:11, color:hbcp.inkLight, marginTop:6}}>{d.sub}</div>
                </div>
              ))}
            </div>

            {/* 受験生 / 有資格者 */}
            <div style={{padding:'28px 32px', background:hbcp.paper, borderLeft:`3px solid ${hbcp.blue}`}}>
              <div style={{fontFamily:fontJP, fontSize:13, color:hbcp.inkLight, fontWeight:600, marginBottom:14}}>● 会計士・税理士 受験生 / 有資格者 (過去の在籍者・業務委託も含む)</div>
              <div className="hb-r-grid-qualify" style={{display:'grid', gridTemplateColumns:`repeat(${DATA_QUALIFY.length}, 1fr)`, gap:24}}>
                {DATA_QUALIFY.map( q => (
                  <div key={q.label} style={{display:'flex', flexDirection:'column', gap:6, paddingRight:20, borderRight: q === DATA_QUALIFY[ DATA_QUALIFY.length - 1 ] ? 'none' : `1px solid ${hbcp.line}`}}>
                    <span style={{fontFamily:fontEN, fontWeight:300, fontSize:30, color:hbcp.blue, lineHeight:1}}>{q.v}</span>
                    <span style={{fontFamily:fontJP, fontSize:12, color:hbcp.ink, fontWeight:600}}>{q.label}</span>
                  </div>
                ))}
              </div>
            </div>
          </div>
        </section>

        {/* ───── 5. MEMBERS ───── */}
        <section className="hb-r-section" style={{padding:'96px 32px', background:hbcp.paper, borderBottom:`1px solid ${hbcp.line}`}}>
          <div style={{maxWidth:1280, margin:'0 auto'}}>
            <div className="hb-section-head">
              <span className="hb-section-head-en">Members</span>
              <span className="hb-section-head-jp">メンバーの内訳</span>
            </div>
            <p style={{fontSize:15, lineHeight:1.95, color:hbcp.inkSoft, margin:'0 0 36px', maxWidth:780}}>
              はてなベースは、多様なバックグラウンド・家庭環境をもつメンバーが働いてます。年齢・事業部・職種・性別の構成比をご紹介します。事業部別は 2026 年 9 月時点、年齢比・男女比・職種別は 2026 年 5 月時点の集計です。
            </p>

            {/* 年齢 + 男女 */}
            <div className="hb-r-grid-2" style={{display:'grid', gridTemplateColumns:'1fr 1fr', gap:36, marginBottom:48}}>
              {/* 年齢 */}
              <div style={{padding:'32px', background:'#fff', border:`1px solid ${hbcp.line}`}}>
                <div style={{fontFamily:fontENSans, fontSize:10, letterSpacing:'.32em', color:hbcp.blue, fontWeight:700, marginBottom:6}}>● AGE</div>
                <h3 style={{fontFamily:fontJP, fontWeight:700, fontSize:18, margin:'0 0 8px'}}>年齢比 <span style={{fontFamily:fontJP, fontSize:13, fontWeight:500, color:hbcp.inkLight}}>(2026 年 5 月時点・全 58 名 中、20 代が 65%)</span></h3>
                <div className="hb-r-pie-legend" style={{display:'grid', gridTemplateColumns:'auto 1fr', gap:32, alignItems:'center'}}>
                  <PieChart data={MEMBERS_AGE} size={200}/>
                  <div>
                    {MEMBERS_AGE.map( a => (
                      <div key={a.label} style={{display:'flex', alignItems:'baseline', gap:12, padding:'8px 0', borderBottom:`1px solid ${hbcp.line}`}}>
                        <span style={{width:14, height:14, background:a.color, flexShrink:0, borderRadius:2}}/>
                        <span style={{fontFamily:fontJP, fontSize:13, fontWeight:600}}>{a.label}</span>
                        <span style={{flex:1, height:1, background:hbcp.line}}/>
                        <span style={{fontFamily:fontMono, fontSize:11, color:hbcp.inkLight}}>{a.n} 名 ・ {a.pct}%</span>
                      </div>
                    ))}
                  </div>
                </div>
              </div>

              {/* 男女 */}
              <div style={{padding:'32px', background:'#fff', border:`1px solid ${hbcp.line}`}}>
                <div style={{fontFamily:fontENSans, fontSize:10, letterSpacing:'.32em', color:hbcp.blue, fontWeight:700, marginBottom:6}}>● GENDER</div>
                <h3 style={{fontFamily:fontJP, fontWeight:700, fontSize:18, margin:'0 0 28px'}}>男女の構成比 <span style={{fontFamily:fontJP, fontSize:13, fontWeight:500, color:hbcp.inkLight}}>(2026 年 5 月時点)</span></h3>
                <div style={{display:'flex', gap:0, height:48, marginBottom:18}}>
                  {MEMBERS_GENDER.map( (g, i) => (
                    <div key={g.label} style={{flex:g.pct, background: i === 0 ? hbcp.blue : '#A65A38', color:'#fff', display:'flex', alignItems:'center', justifyContent:'center', fontFamily:fontJP, fontWeight:700, fontSize:14}}>
                      {g.pct}%
                    </div>
                  ))}
                </div>
                <div style={{display:'grid', gridTemplateColumns:'1fr 1fr', gap:14}}>
                  {MEMBERS_GENDER.map( (g, i) => (
                    <div key={g.label} style={{padding:'14px 16px', background:hbcp.paper, borderLeft:`3px solid ${i === 0 ? hbcp.blue : '#A65A38'}`}}>
                      <div style={{fontFamily:fontJP, fontSize:12, color:hbcp.inkLight, marginBottom:4}}>{g.label}</div>
                      <div style={{fontFamily:fontEN, fontWeight:300, fontSize:24, color:hbcp.ink, lineHeight:1}}>{g.n}<span style={{fontSize:14, marginLeft:4}}>名</span></div>
                    </div>
                  ))}
                </div>
              </div>
            </div>

            {/* 事業部 + 職種 */}
            <div className="hb-r-grid-2" style={{display:'grid', gridTemplateColumns:'1fr 1fr', gap:36, marginBottom:48}}>
              {/* 事業部 */}
              <div style={{padding:'32px', background:'#fff', border:`1px solid ${hbcp.line}`}}>
                <div style={{fontFamily:fontENSans, fontSize:10, letterSpacing:'.32em', color:hbcp.blue, fontWeight:700, marginBottom:6}}>● DEPARTMENT</div>
                <h3 style={{fontFamily:fontJP, fontWeight:700, fontSize:18, margin:'0 0 18px'}}>事業部別構成 <span style={{fontFamily:fontJP, fontSize:13, fontWeight:500, color:hbcp.inkLight}}>(2026 年 9 月時点・計 {totalDept} 名)</span></h3>
                {MEMBERS_DEPT.map( (d, i) => (
                  <BarRow key={d.label} label={d.label} n={d.n} total={totalDept} color={['#1F4F8F','#1A4D4D','#A65A38','#5C2B45'][i]}/>
                ))}
              </div>

              {/* 職種 */}
              <div style={{padding:'32px', background:'#fff', border:`1px solid ${hbcp.line}`}}>
                <div style={{fontFamily:fontENSans, fontSize:10, letterSpacing:'.32em', color:hbcp.blue, fontWeight:700, marginBottom:6}}>● ROLE</div>
                <h3 style={{fontFamily:fontJP, fontWeight:700, fontSize:18, margin:'0 0 18px'}}>職種別構成 <span style={{fontFamily:fontJP, fontSize:13, fontWeight:500, color:hbcp.inkLight}}>(2026 年 5 月時点・計 {totalJob} 名)</span></h3>
                {MEMBERS_JOB.map( j => (
                  <BarRow key={j.label} label={j.label} n={j.n} total={totalJob}/>
                ))}
              </div>
            </div>

          </div>
        </section>

        {/* ───── 6. TEAM MEMBERS ───── */}
        <section className="hb-r-section" style={{padding:'96px 32px', background:hbcp.white, borderBottom:`1px solid ${hbcp.line}`}}>
          <div style={{maxWidth:1280, margin:'0 auto'}}>
            <div className="hb-section-head">
              <span className="hb-section-head-en">Team Members</span>
              <span className="hb-section-head-jp">チームメンバー</span>
            </div>
            <p style={{fontSize:14, lineHeight:1.95, color:hbcp.inkSoft, margin:'0 0 36px', maxWidth:680}}>
              事業を引っ張るメンバーをご紹介します。
            </p>
            <div className="hb-r-grid-team" style={{display:'grid', gridTemplateColumns:'repeat(2, 1fr)', gap:24}}>
              {TEAM.map( m => (
                <article key={m.name} className="hb-r-team-card" style={{display:'grid', gridTemplateColumns:'200px 1fr', gap:24, padding:24, border:`1px solid ${hbcp.line}`, background:hbcp.paper}}>
                  <div style={{aspectRatio:'1/1', overflow:'hidden', background:'#fff', border:`1px solid ${hbcp.line}`}}>
                    <img src={m.img} alt={m.name} style={{width:'100%', height:'100%', objectFit:'cover', display:'block'}}/>
                  </div>
                  <div>
                    <div style={{fontFamily:fontENSans, fontSize:9.5, letterSpacing:'.28em', color:hbcp.blue, fontWeight:700, marginBottom:6}}>● {m.role}</div>
                    <h3 style={{fontFamily:fontJP, fontWeight:700, fontSize:20, margin:'0 0 12px', color:hbcp.ink, letterSpacing:'.04em'}}>{m.name}</h3>
                    <p style={{fontSize:12.5, lineHeight:1.85, color:hbcp.inkSoft, margin:0}}>{m.bio}</p>
                  </div>
                </article>
              ))}
            </div>
          </div>
        </section>

        {/* ───── 7. VALUES ───── */}
        <section className="hb-r-section" style={{padding:'96px 32px', background:hbcp.paper, borderBottom:`1px solid ${hbcp.line}`}}>
          <div style={{maxWidth:1280, margin:'0 auto'}}>
            <div className="hb-section-head">
              <span className="hb-section-head-en">Values</span>
              <span className="hb-section-head-jp">行動原則</span>
            </div>
            <div className="hb-r-grid-3" style={{display:'grid', gridTemplateColumns:'repeat(3, 1fr)', borderTop:`1px solid ${hbcp.line}`, borderLeft:`1px solid ${hbcp.line}`, marginTop:14}}>
              {VALUES.map( v => (
                <div key={v.num} style={{padding:'40px 32px', borderRight:`1px solid ${hbcp.line}`, borderBottom:`1px solid ${hbcp.line}`, background:'#fff'}}>
                  <div style={{display:'flex', alignItems:'baseline', gap:14, marginBottom:18}}>
                    <span style={{fontFamily:fontEN, fontWeight:300, fontSize:36, color:hbcp.blue, lineHeight:1}}>{v.num}</span>
                    <span style={{fontFamily:fontENSans, fontSize:11, letterSpacing:'.28em', color:hbcp.inkLight, fontWeight:700}}>{v.en.toUpperCase()}</span>
                  </div>
                  <h3 style={{fontFamily:fontJP, fontWeight:700, fontSize:20, lineHeight:1.45, letterSpacing:'.04em', margin:'0 0 14px'}}>{v.jp}</h3>
                  <p style={{fontSize:14, lineHeight:1.95, color:hbcp.inkSoft, margin:0}}>{v.d}</p>
                </div>
              ))}
            </div>
          </div>
        </section>

        {/* ───── 8. OFFICE & TEAM ───── */}
        <section className="hb-r-section" style={{padding:'96px 32px', background:hbcp.white, borderBottom:`1px solid ${hbcp.line}`}}>
          <div style={{maxWidth:1280, margin:'0 auto'}}>
            <div className="hb-section-head">
              <span className="hb-section-head-en">Office &amp; Team</span>
              <span className="hb-section-head-jp">オフィス・働く環境</span>
            </div>
            <div className="hb-r-office-wide" style={{display:'grid', gridTemplateColumns:'1.6fr 1fr', gap:18, marginBottom:18}}>
              <div style={{aspectRatio:'16/9', overflow:'hidden', background:hbcp.paper, border:`1px solid ${hbcp.line}`}}>
                <img src={(window.HB_ASSETS||'')+"images/office/office-team-work.jpg"} alt="DX 事業部チーム作業風景" style={{width:'100%', height:'100%', objectFit:'cover', display:'block'}}/>
              </div>
              <div style={{aspectRatio:'16/9', overflow:'hidden', background:hbcp.paper, border:`1px solid ${hbcp.line}`}}>
                <img src={(window.HB_ASSETS||'')+"images/office/office-logo.jpg"} alt="HatenaBase 認定証 + cybozu OFFICIAL PARTNER" style={{width:'100%', height:'100%', objectFit:'cover', display:'block'}}/>
              </div>
            </div>
            <div className="hb-r-grid-4" style={{display:'grid', gridTemplateColumns:'repeat(4, 1fr)', gap:18}}>
              {[
                {src:(window.HB_ASSETS||'')+'images/office/office-pair-work.jpg',    alt:'メンバー作業風景',     cap:'専門領域を越えて手を動かす内製チーム'},
                {src:(window.HB_ASSETS||'')+'images/office/office-focus-work.jpg',   alt:'集中作業',              cap:'数字とプロセスに向き合う仕事場'},
                {src:(window.HB_ASSETS||'')+'images/office/office-dual-monitor.jpg', alt:'デュアルモニタ作業',    cap:'四谷三丁目の新オフィス'},
                {src:(window.HB_ASSETS||'')+'images/office/office-smile.jpg',        alt:'働くメンバー',          cap:'メンバー間のコミュニケーション'},
              ].map(p => (
                <figure key={p.src} style={{margin:0}}>
                  <div style={{aspectRatio:'4/3', overflow:'hidden', background:hbcp.paper, border:`1px solid ${hbcp.line}`}}>
                    <img src={p.src} alt={p.alt} style={{width:'100%', height:'100%', objectFit:'cover', display:'block'}}/>
                  </div>
                  <figcaption style={{marginTop:10, fontFamily:fontJP, fontSize:12, color:hbcp.inkSoft, lineHeight:1.6}}>{p.cap}</figcaption>
                </figure>
              ))}
            </div>
            <div style={{marginTop:32, display:'flex', alignItems:'center', justifyContent:'space-between', borderTop:`1px solid ${hbcp.line}`, paddingTop:24, gap:24, flexWrap:'wrap'}}>
              <p style={{fontSize:13, color:hbcp.inkSoft, margin:0, lineHeight:1.8}}>
                チーム・オフィスの最新の様子は Wantedly でも公開しています。日々の仕事や最近のイベントの様子をご覧ください。
              </p>
              <a href={HB_WANTEDLY} target="_blank" rel="noopener noreferrer"
                 style={{fontFamily:fontJP, fontSize:13, fontWeight:700, color:hbcp.blue, textDecoration:'none', borderBottom:`1px solid ${hbcp.blue}`, paddingBottom:2, whiteSpace:'nowrap'}}>
                Wantedly で見る <span style={{fontFamily:fontEN}}>↗</span>
              </a>
            </div>
          </div>
        </section>

      </HBLayout>
    );
  }

  Object.assign(window, { RecruitCompanyPage });
})();
